import React from "react";

export default function NewSinceLoginPill() {
  return (
    <span
      className="inline-flex items-center rounded-full bg-blue-500 px-1.5 py-px text-[8px] leading-none font-['Manrope'] font-semibold uppercase tracking-wide text-white"
      data-testid="new-since-login"
    >
      NEW
    </span>
  );
}
